export default {
  create: 'Create Budget Simulation',
  createFromScratch: 'From scratch',
  createLastYearFree: 'Last Year, Free',
  createLastYearFrozen: 'Last Year, Frozen',
  createNextYearFree: 'Next Year, Free',
  chooseSubtitle: 'Start from a blank simulation or let a template fill in the period and budget for you.',
  chooseFromScratchDescription: 'Set the period, reference budget and mix mode yourself.',
  chooseLastYearFreeTitle: 'Last Year, Free Mix',
  chooseLastYearFreeDescription: 'The last 12 months of data, with the optimizer picking the best mix at each budget.',
  chooseLastYearFrozenTitle: 'Last Year, Frozen Mix',
  chooseLastYearFrozenDescription: 'The last 12 months of data, with every budget keeping that period\'s historical channel mix.',
  chooseNextYearFreeTitle: 'Next Year, Free Mix',
  chooseNextYearFreeDescription: 'The model\'s propagated budget for the upcoming year, with the optimizer picking the best mix at each budget.',
  chooseTagStrategyCheck: 'Strategy Check',
  chooseTagForwardLooking: 'Forward Looking',
  createFlexibleDates: 'Flexible Dates',
  chooseFlexibleTitle: 'Flexible Dates',
  chooseTagFlexible: 'Flexible',
  flexibleSummaryActual: 'Actual spend',
  flexibleSummaryPropagation: 'Budget propagation',
  flexibleSummaryEmpty: 'No data, adds 0',
  flexibleMonths: '{count} month | {count} months',
  flexibleWeeks: '{count} week | {count} weeks',
  flexibleHintActual: 'Actual spend is available through {date}.',
  flexibleHintPropagation: 'Budget propagation covers {from} to {to}.',
  chooseFlexibleDescription: 'Pick any period: its reference budget and Frozen mix add up the actual spend where the model has it and the budget propagation after that.',
  flexibleSummaryTotal: 'Reference budget',
  flexibleHintMix: 'The simulation starts with a Free mix, which you can switch to Frozen in the next step.',
  chooseNeedsMediaSpend: 'Requires media spend data in the model report',
  chooseNeedsBudgetPropagation: 'Requires budget propagation data in the model report',
  loading: 'Loading budget simulations...',
  noSimulations: 'No budget simulations yet',
  search: 'Search',
  ready: 'Ready',
  running: 'Running... {done}/{total}',
  headerName: 'Name',
  headerMixMode: 'Mix Mode',
  headerPeriod: 'Period',
  headerProgress: 'Status',
  headerCreated: 'Created',
  copy: 'copy',
  gridRange: '{from}%–{to}% · {count} budgets',
  headerReferenceBudget: 'Reference Budget ({unit})',
  sharedWithExternalUsers: 'Shared with external users'
}
